import { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'

import TextField from '../../../FormLegacy/FormFieldsV2/TextField'
import API from '../../../../api/api'

const ImagesDatabase = ({ formState, handleFieldChange }) => {
  const { t } = useTranslation(['create-event'])
  const [query, setQuery] = useState(formState.eventName)
  const [images, setImages] = useState([])

  const debouncedGetImages = useMemo(() => {
    return debounce(async (query) => {
      const resp = await API.getUnsplashImages(query)
      if (resp.status === 200) {
        setImages(resp.data.pictures)
      }
    }, 400)
  }, [])

  useEffect(() => {
    debouncedGetImages(query)
  }, [query, debouncedGetImages])

  const handleSelectImage = (image) => {
    handleFieldChange({ target: { name: 'image', value: image } })
    handleFieldChange({ target: { name: 'imagesDatabaseOpen', value: false } })
  }

  return (
    <div className="images-database event-form-images-database">
      <div className="event-form-images-database__header">
        <div>{t('create-event:imagesDatabase.findPerfectImage')}</div>
        <TextField value={query} onChange={(e) => setQuery(e.target.value)} name="query" />
      </div>
      <div className="database-image-wrapper images-container">
        {images.map((image) => (
          <div className="database-image-item" key={image.id}>
            <div role="button" onClick={() => handleSelectImage(image)}>
              <img src={image.url} alt={image.description} />
            </div>
            <p className="image-author">
              {t('create-event:imagesDatabase.photoByPrefix')}{' '}
              <a href={image.photographerProfile} target="_blank">
                {image.photographerName}
              </a>{' '}
              {t('create-event:imagesDatabase.onPrefix')}{' '}
              <a href={image.url} rel="noreferrer" target="_blank">
                {t('create-event:imagesDatabase.unsplash')}
              </a>
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

ImagesDatabase.propTypes = {
  formState: PropTypes.object,
  handleFieldChange: PropTypes.func,
}

export default ImagesDatabase
